import { BaseService } from "services/_baseService";

class BaggageTariffsAdminService extends BaseService<any> {
  constructor() {
    super(`baggage-tariffs`);
  }
}

export default new BaggageTariffsAdminService();
